import _ from 'lodash';
import { saveAs } from 'file-saver';

export const downloadFromLink = (linkData: any, fileName: string) => {
  const link = document.createElement("a");
  link.setAttribute('download', fileName);
  link.href = _.get(linkData, 'document.documentPath');
  document.body.appendChild(link);
  link.click();
  link.remove();
}


export const downloadFromBase64 = (linkData: any, name: string) => {
  const blob = b64toBlob(linkData, 'csv');
  const blobUrl = URL.createObjectURL(blob);

  const link = document.createElement("a");
  if (link.download !== undefined) {
    link.href = blobUrl;
    link.target = '_blank';
    link.download = name;
    link.click();
    link.remove();
    URL.revokeObjectURL(blobUrl);
  };
}

export const b64toBlob = (b64Data: string, contentType = '', sliceSize = 512) => {
  const byteCharacters = atob(b64Data);
  const byteArrays = [];

  for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
    const slice = byteCharacters.slice(offset, offset + sliceSize);

    const byteNumbers = new Array(slice.length);
    for (let i = 0; i < slice.length; i++) {
      byteNumbers[i] = slice.charCodeAt(i);
    }

    const byteArray = new Uint8Array(byteNumbers);
    byteArrays.push(byteArray);
  }

  const blob = new Blob(byteArrays, { type: contentType });
  return blob;
}

export const SASTokenParser = (sasToken: any) => {
  const params = sasToken.split('&');
  let queryString = '';
  params.forEach((param: any) => {
    const keyValue = param.split('=');
    queryString = `${queryString}&${keyValue[0]}=${encodeURIComponent(keyValue.slice(1, keyValue.length).join('='))}`;
  });
  return queryString.slice(1);
}

export const convertBase64ToFile = (base64String: any, fileName: string) => {
  let arr = base64String.split(',');
  let mime = arr[0].match(/:(.*?);/)[1];
  let bstr = atob(arr[1]);
  let n = bstr.length;
  let uint8Array = new Uint8Array(n);
  while (n--) {
    uint8Array[n] = bstr.charCodeAt(n);
  }
  let file = new File([uint8Array], fileName, { type: mime });
  return file;
}

export const downloadBase64Data = (base64String: any, fileName: string) => {
  let file = convertBase64ToFile(base64String, fileName);
  saveAs(file, fileName);
}

export const getDocumentPath = (document: any) => {
  const imgUrl = (document && document.documentPath) ? `${document.documentPath}${document.sasToken}` : 'assets/images/default-grid-image.png';
  // const imgUrl = (document && document.documentName) ? `https://${document.storagePath}/${document.containerName}/${document.documentName}.${document.documentExtension}${SASTokenParser(document.sasToken)}` : 'assets/images/default-grid-image.png';

  return imgUrl;
}

